function openSesame(id, index) {
  var tabid = id + "-tab-" + index;

  var i;
  var x = document.getElementById(id).getElementsByClassName("tab-block");
  for (i = 0; i < x.length; i++) {
    x[i].style.display = "none";  
  }

  document.getElementById(tabid).style.display = "block";

  $('#' + id + ' .home-collection-tabs li').on('click', function(){
    $('#' + id + ' .home-collection-tabs li.tab-active').removeClass('tab-active');
    $(this).addClass('tab-active');
  });
}